// This file contains alpha data to develop multi-day trail pages before server sends down the needed data

export const tmbId = 10266863;

export const tmbSlug = 'trail/france/auvergne-rhone-alpes/tour-du-mont-blanc';

export const tmbSegmentIds = [10422365, 10422364, 10422363, 10422361, 10422267, 10422359, 10422356, 10422290, 10422288, 10422287, 10422285];
